import bindOnCartUpdate from './bindOnCartUpdate';

/**
 * Initialize the cart page event
 * @param {Object} pageEvent - The page event object
 * @param {Function} pageEvent.onCartUpdate - callback function when cart is updated
 */
const initCartPageEvent = (pageEvent) =>
  bindOnCartUpdate(pageEvent.onCartUpdate);

export default initCartPageEvent;
